import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=05c0cb60&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=ts"
export * from "./NotificationsList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=05c0cb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c0cb60",
  null
  
)

export default component.exports